import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit {

  constructor() { }

  @Output() onInit:EventEmitter<any> = new EventEmitter<any>();
  @Input()
  set settings(value:any){
    console.log(value);
    this.data=value.data;
    this.columns=value.columns;
    this.pageSize=value.pageSize;
    this.mode = value.mode;
    this.searchAlign = value.searchAlign;
    this.loading = value.loading;
    this.error = value.error?value.error:'';

    this.designData();
    this.setResultCountMsg();
    this.setSearchObj();
  }

  data:any[]=[];
  columns:any[]= [];
  filterColumns:any[]=[];
  pageSize:number =-1;
  mode:string='table';
  searchAlign:string='top';
  loading:boolean=true;
  error:string='';

  resultCountMsg:string='';
  searchText:string='';
  searchObj:any={};
  orgData:any[]=[];
  exSearchIsOpen:boolean=true;

  ngOnInit(): void {
    this.onInit.emit();
  }

  designData():void{
    this.columns.filter(x=>x.type.indexOf('date_')==0).forEach(col=>{
      this.data.forEach(row=>{
        //row[col.field] = this.getDateSpan(row[col.field]);
        Object.defineProperty(row,col.field+'_text',{value:this.getDateSpan(row[col.field]),enumerable: true});
      })
    });
    this.columns.filter(x=>x.type=='routerLink' || x.type=='linkTitle').forEach(col=>{
      this.data.forEach(row=>{
        const params:any={};
        col.params.forEach((p:any)=>{
          Object.defineProperty(params,p.name,{value:row[p.field],enumerable: true});
        });
        //row[col.field] = params;
        Object.defineProperty(row,col.field+'_params',{value:params,enumerable: true});
      })
    });
    this.columns.filter(x=>x.type=='lookup').forEach(col=>{
      this.data.forEach(row=>{
        //row[col.field] = row[col.params.object][col.params.value];
        Object.defineProperty(row,col.field+'_text',{value:row[col.params.object][col.params.value],enumerable: true});
      })
    });
    this.orgData = this.data.filter(x=>true);
  }

  setResultCountMsg():void{
    if(this.data.length==0)
      this.resultCountMsg = 'לא נמצאו תוצאות';
    else
      this.resultCountMsg = 'תוצאות '+((this.startPage-1)*this.pageSize+1)+' - '+((this.startPage-1)*this.pageSize+this.pageSize<this.data.length?(this.startPage-1)*this.pageSize+this.pageSize:this.data.length)+' מתוך '+this.data.length;
  }

  setSearchObj():void{
    this.filterColumns = this.columns.filter(c=>c.searchable==true);
    this.filterColumns.forEach((col:any)=>{
      if(col.type.indexOf('date_')==-1)
        Object.defineProperty(this.searchObj,col.field,{value:null,enumerable: true});
      else{
        Object.defineProperty(this.searchObj,col.field+'_start',{value:null,enumerable: true});
        Object.defineProperty(this.searchObj,col.field+'_end',{value:null,enumerable: true});
      }
      if(col.type=='lookup'){
        const arrOptions:Array<any> = this.data.map(x=>{ return {key:x[col.params.object][col.params.key],value:x[col.params.object][col.params.value]}});
        //const groupData:any = this.groupBy(arrOptions, 'key');
        //const arrGroupOptions:any = groupData.map((x:any)=>{return {key:x.key,value:x.value[0].value};});
        const distinctOptions = arrOptions.filter(this.onlyUnique);
        Object.defineProperty(col,'filterOptions',{value:distinctOptions,enumerable: true});
      }
    });
    this.searchObj = JSON.parse(JSON.stringify(this.searchObj));//override read only properties
  }

  onlyUnique(current:any, index:number, arr:any[]) {
    return arr.findIndex(x=>x.key==current.key) === index;
  }

  groupBy(list:any[], keyGetter:any):any {
      var map = new Map();
      list.forEach((item) => {
          var key = item[keyGetter];//keyGetter(item);
          var collection = map.get(key);
          if (!collection) {
              map.set(key, [item]);
          } else {
              collection.push(item);
          }
      });
      return map;
  }

  getDateSpan(jsonDate:string):string{
    if(!jsonDate || jsonDate=='0001-01-01T00:00:00')
      return '';
    return '<span><style>.hiddenJsonDate{display:none}</style><span class="hiddenJsonDate">'+jsonDate+'</span>'+this.getDdMmYyyy(jsonDate)+'</span>';  
  }

  getDdMmYyyy(jsonDate:string):string{
    const split:string[] = jsonDate.split('T')[0].split('-');
    return split[2]+'/'+split[1]+'/'+split[0];
  }

  sortField:string='';
  sortUp:boolean=true;

  sortData(col:any){
    this.sortUp = this.sortField == col.field? !this.sortUp : true;
    this.sortField = col.field;
    if(this.sortUp)
      this.data.sort((a:any,b:any)=>a[this.sortField]>b[this.sortField]?1:a[this.sortField]<b[this.sortField]?-1:0);
    else
      this.data.sort((a:any,b:any)=>a[this.sortField]>b[this.sortField]?-1:a[this.sortField]<b[this.sortField]?1:0);
  }

  startPage:number = 1;
  paging(page:number,next:boolean):void{
    if(page==0){//next or prev
      if(next){
        if((this.startPage-1)*this.pageSize < this.data.length)//last page
          this.startPage++;
        else
          return;
      }
      else{//prev
        if(this.startPage==1)//fisrt page
          return;
        else
          this.startPage--;
      }
    }
    else if(page==-1){//first or last
      if(next){
        this.startPage = Math.ceil(this.data.length/this.pageSize);
      }
      else{//prev
        this.startPage = 1;
      }
    }
    this.setResultCountMsg();
  }

  JsonStringify(o:any):string{
    return JSON.stringify(o);
  }

  filter():void{
    if(!this.exSearchIsOpen){
      if(!this.searchText)
        this.data = this.orgData.filter(x=>true);
      else
        this.data = this.orgData.filter(x=>this.isRight(x));
    }
    else{
      this.exFilter();
      if(!this.searchText)
        this.data = this.data.filter(x=>true);
      else
        this.data = this.data.filter(x=>this.isRight(x));      
    }
    this.setResultCountMsg();
  }

  isRight(row:any):boolean{
    if(this.columns.filter(col=>col.type!='routerLink').findIndex(col=>row[col.field] && row[col.field].toString().indexOf(this.searchText)>-1)>-1)
      return true;
    return false;
  }

  isCondition(row:any,col:any):boolean{
    //condition:{type:'date',compare:'<=',field:'MolsaTenderQADate',value:new Date().toJSON()}
    const x:any = col.condition.type=='number'?Number(row[col.condition.field]):row[col.condition.field];
    const y:any = col.condition.value; 
    switch(col.condition.compare){
      case '=': return x==y;  break;
      case '!=': return x!=y;  break;
      case '<': return x<y;  break;
      case '<=': return x<=y;  break;
      case '>': return x>y;  break;
      case '<=': return x>=y;  break;
      default:
        return false;
    }
  }

  isPayment(value:any):boolean{
    if(Number(value)<=0)
      return false;
    return true;
  }

  pay(row:any,encryptPaymentCol:any):void{
    if(!confirm('הנכם מועברים לביצוע התשלום מקוון באתר שרות התשלומים הממשלתי. ניתן לחזור בכל שלב לאתר משרד הרווחה באמצעות הקישור בשורת הניווט')) 
      return;
    var frmPayment = document.createElement("form");
    frmPayment.setAttribute("name","_payform");
    frmPayment.setAttribute("action", environment.govPaynetUrl);
    frmPayment.setAttribute("method", "post");
    var inputHiddenValue = document.createElement("input");
    inputHiddenValue.setAttribute("name","enc_string");
    inputHiddenValue.setAttribute("id","enc_string");
    inputHiddenValue.setAttribute("type", "hidden");
    inputHiddenValue.setAttribute("value", row[encryptPaymentCol]);
    frmPayment.appendChild(inputHiddenValue);
    var submitPaymentBtn = document.createElement("input");
    submitPaymentBtn.setAttribute("type", "submit");
    submitPaymentBtn.setAttribute("value", "");
    frmPayment.appendChild(submitPaymentBtn);
    document.body.appendChild(frmPayment);
    frmPayment.submit();
    if (frmPayment.parentNode){
      frmPayment.parentNode.removeChild(frmPayment);
    }
  }

  openExSearch():void{
    this.exSearchIsOpen = !this.exSearchIsOpen;
  }

  exFilter():void{
    console.log(this.searchObj);
    this.data =this.orgData.filter(x=>true);
    let filterValue:any;
    this.columns.filter(c=>c.searchable==true).forEach((col:any)=>{
      filterValue = col.type.indexOf('date_')==0?(col.type == 'date_range' || col.type=='date_start'?this.searchObj[col.field+'_start']:this.searchObj[col.field+'_end']):this.searchObj[col.field];
      if(filterValue || col.type=='date_range'){
        switch(col.type){
          case 'date_range':{
            if(filterValue){
              ///filterValue = filterValue.toJSON();
              this.data = this.data.filter(x=>x[col.field]>=filterValue);
            }
            filterValue =this.searchObj[col.field+'_end']; 
            if(filterValue){
              //filterValue = filterValue.toJSON();
              this.data = this.data.filter(x=>x[col.field]<=filterValue);
            }
          };break;
          case 'date_start':{
            this.data = this.data.filter(x=>x[col.field]>=filterValue);
          };break;
          case 'date_end':{
            this.data = this.data.filter(x=>x[col.field]<=filterValue);
          };break;
          case 'lookup': this.data = this.data.filter(x=>x[col.params.object][col.params.key]==filterValue);break;
          case 'string':
          case 'linkTitle': 
            this.data = this.data.filter(x=>x[col.field].indexOf(filterValue)>-1);;break;
          default: this.data = this.data.filter(x=>x[col.field]==filterValue);;break;
        }
      }
    });
    this.setResultCountMsg();
  }

  clearFilter():void{
    Object.keys(this.searchObj).forEach(key=>this.searchObj[key]=null);
    this.data = this.orgData.filter(x=>true);
    this.setResultCountMsg();
  }
}
